/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Visibility_Just_Me_DescInputs */

const en_dialog_visibility_just_me_desc = /** @type {(inputs: Dialog_Visibility_Just_Me_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you can view this file`)
};

const es_dialog_visibility_just_me_desc = /** @type {(inputs: Dialog_Visibility_Just_Me_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo tú puedes ver este archivo`)
};

/**
* | output |
* | --- |
* | "Only you can view this file" |
*
* @param {Dialog_Visibility_Just_Me_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_visibility_just_me_desc = /** @type {((inputs?: Dialog_Visibility_Just_Me_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Visibility_Just_Me_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_visibility_just_me_desc(inputs)
	return en_dialog_visibility_just_me_desc(inputs)
});